module.exports = __webpack_public_path__ + "img/chat_input_delEmoji.3dc62100.png";